import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { usePwaUpdate } from "../hooks/usePwaUpdate";

/** Persistent app update row on Notifications (installed PWA only). */
export default function AppUpdateNotificationCard() {
  const { hasPendingUpdate, applyUpdate, dismissBanner, isInstalledPwa } = usePwaUpdate();

  if (!isInstalledPwa || !hasPendingUpdate) return null;

  return (
    <Card className="shadow-soft border-accent/30 min-w-0 overflow-hidden">
      <CardHeader className="min-w-0">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
          <RefreshCw className="h-5 w-5 shrink-0 text-accent" />
          App update available
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3 min-w-0">
        <p className="text-sm text-muted-foreground leading-relaxed">
          A new version of your installed Smart Farming app is ready. Update now or come back here anytime — same as
          firmware updates below.
        </p>
        <div className="flex flex-col sm:flex-row flex-wrap gap-2 w-full">
          <Button className="w-full sm:w-auto" onClick={applyUpdate}>
            Update app now
          </Button>
          <Button className="w-full sm:w-auto" variant="outline" onClick={dismissBanner}>
            Remind me later
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
